import { Image, Label, FontIcon, Stack } from '@fluentui/react';
import React, { useContext } from 'react';
import styles from '../styles/pokemon.module.scss';
import GlobalContext from '../_contexts/GlobalContext';

export interface IHeaderInfoComponentProps {
}

const HeaderInfoComponent : React.FunctionComponent<IHeaderInfoComponentProps> = (props : IHeaderInfoComponentProps) => {
    const { Strings } = useContext(GlobalContext);

    return (
        <div className={`${styles.divTable} ${styles.headerInfoMain}`}>
            <div className={styles.divTableRow}>
                <div className={styles.divTableCell} style={{width:25}}>
                    <div className={styles.headerInfoImg}></div>
                </div>
                <div className={styles.divTableCell}>
                    <Label className={styles.headerInfoLabel}>{Strings.CardsSleeved}</Label>
                </div>
            </div>
            <div className={styles.divTableRow}>
                <div className={styles.divTableCell} style={{width:25}}>
                    &nbsp;<FontIcon aria-label="Track en Trace" iconName="ExerciseTracker" className={styles.headerInfoIcon} />
                </div>
                <div className={styles.divTableCell}>
                    <Label className={styles.headerInfoLabel}>{Strings.TT}</Label>
                </div>
            </div>
            <div className={styles.divTableRow}>
                <div className={styles.divTableCell} style={{width:25}}>
                &nbsp;<FontIcon aria-label="Betaling" iconName="PaymentCard" className={styles.headerInfoIcon} />
                </div>
                <div className={styles.divTableCell}>
                    <Label className={styles.headerInfoLabel}>{Strings.PaymentMethods}</Label>
                </div>
            </div>
            <div className={styles.divTableRow}>
                <div className={styles.divTableCell} style={{width:25}}>
                    <div className={styles.headerInfoImgFree}></div>
                </div>
                <div className={styles.divTableCell}>
                    <Label className={styles.headerInfoLabel}>{Strings.BonusCards}</Label>
                </div>
            </div>
        </div>
    );
}

export default HeaderInfoComponent;